import { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import Submission from './Submission'
import { useSelector } from 'react-redux'

function FormSubmissions({
  formId,
  setShowFormSubmissions,
  setHasSubmissions,
  lastForm,
  refreshKey,
}) {
  const [submissions, setSubmissions] = useState([])
  //leart
  const {
    selectedLocation,
    selectedStatus,
    selectedStartDate,
    selectedEndDate,
  } = useSelector((store) => store.form)
  const { disableLocationForms } = useSelector((store) => store.generalConfig)

  useEffect(() => {
    const params = new URLSearchParams()

    if (selectedLocation?.option?.id)
      params.append('location', selectedLocation.option.id)
    if (selectedStatus?.option?.value)
      params.append('status', selectedStatus.option.value)
    if (selectedStartDate)
      params.append('startDate', selectedStartDate.format('YYYY-MM-DD'))
    if (selectedEndDate)
      params.append('endDate', selectedEndDate.format('YYYY-MM-DD'))

    AxiosInstance.get(`/forms/submissions/${formId}?${params.toString()}`).then(
      (data) => {
        if (!data.length) {
          setShowFormSubmissions(false)
          setHasSubmissions(0)
        }
        setSubmissions(data)
      }
    )
  }, [
    formId,
    selectedLocation,
    selectedStatus,
    selectedStartDate,
    selectedEndDate,
    refreshKey,
    setShowFormSubmissions,
    setHasSubmissions,
  ])

  return (
    <div className='w-100'>
      <div className='w-100 bg-secondary py-2 d-flex align-items-center justify-content-between px-5'>
        <p className='font-weight-bold flex-item-employee'>User</p>
        <p className='font-weight-bold flex-item-employee'>Status</p>
        <p className='font-weight-bold flex-item-employee'>Date</p>
        {!disableLocationForms && (
          <p className='font-weight-bold flex-item-employee'>Location</p>
        )}
        <p className='font-weight-bold flex-item-employee invisible'>Action</p>
      </div>
      {submissions && submissions.length
        ? submissions.map((submission, index) => (
            <Submission
              key={submission.id}
              submission={submission}
              index={index}
              setSubmissions={setSubmissions}
              lastSubmission={lastForm && index === submissions.length - 1}
              hideLocation={disableLocationForms}
            />
          ))
        : null}
    </div>
  )
}

export default FormSubmissions
